import { StringBuffer } from './stringBuffer';
export class TelsLmsFormatter {
	/**
	 * フォーマットを行う。
	 * @param command コマンド
	 * @param element エレメント
	 * @param value 値
	 * @return フォーマットされた文字列
	 */
	public format(
		command: string | null | undefined,
		element: string | null | undefined,
		value: string | null | undefined
	) {
		if (command === null || command === undefined || command.length === 0) {
			throw new Error('引数が不正です。');
		}
		const buf = new StringBuffer();
		buf.append('<lms-message ' + 'command="' + command + '"');
		if (element !== null && element !== undefined) {
			buf.append(' element="' + element + '"');
		}
		if (value != null && value !== undefined) {
			buf.append(' value="' + value + '"');
		}
		buf.append('/>');
		return buf.toString();
	}

	/**
	 * はじまりのタグ
	 * @return はじめのタグ
	 */
	public begin() {
		return '<?xml version="1.0" encoding="utf-8"?><cmi>';
	}

	/**
	 * 終わりのタグ
	 * @return 終わりのタグ
	 */
	public end() {
		return '</cmi>';
	}
}



// WEBPACK FOOTER //
// ./src/logic/scorm/impl/legacy/telsFormatter.ts